import { APICore } from './apiCore'

const api = new APICore()

function updatePrivacyPolicy (params) {
  const baseUrl = '/privacy-policy'
  return api.update(baseUrl, params)
}

export { updatePrivacyPolicy }
